import { Component, OnInit, inject } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {Page} from '../../../core/pagination/page';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {Zone} from '../../../zone/zone';
import {ZoneService} from '../../../zone/zone.service';
import {SortOrder} from '../../../core/sort/sort-order';
import {filter, mergeMap, tap} from 'rxjs/operators';
import {DialogService} from '../../../core/dialog/dialog.service';
import {ClientPageRequest} from '../../../client/client-page-request';
import {DienstService} from '../../../dienst/dienst.service';
import {Diensten} from '../../../dienst/diensten';

@Component({
    templateUrl: './clienten.page.html',
    styleUrls: ['./clienten.page.scss'],
    standalone: false
})
export class ClientenPage implements OnInit {
  private clientService = inject(ClientService);
  private zoneService = inject(ZoneService);
  private dienstService = inject(DienstService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  initialPageRequest: ClientPageRequest = ClientPageRequest.firstClientenPageRequest(SortOrder.ASCENDING, 5);
  clientenPage$: Subject<Page<Client>> = new Subject<Page<Client>>();
  zones$: Observable<Array<Zone>>;
  diensten$: Observable<Diensten>;
  private currentPageRequest: ClientPageRequest;

  ngOnInit(): void {
    this.getClienten$(this.initialPageRequest).subscribe();
    this.zones$ = this.zoneService.getZones$();
    this.diensten$ = this.dienstService.getDiensten$();
  }

  navigateToClient(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }

  navigateToMeldingen(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/meldingen`);
  }

  navigateToPrestaties(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/prestaties`);
  }

  navigateToSignaalkaarten(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/signaalkaarten`);
  }

  navigateToEditClient(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/wijzigen`);
  }

  navigateToClientFiche(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/fiche/beheer`);
  }

  archiveClient(client: Client): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${client.getVoornaam()} wil archiveren?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.clientService.archiveer(client.getId())),
        mergeMap(() => this.clientService.getClienten$(this.currentPageRequest)),
      )
      .subscribe(page => this.clientenPage$.next(page));
  }

  unarchiveClient(client: Client): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${client.getVoornaam()} wil heractiveren?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.clientService.activeer(client.getId())),
        mergeMap(() => this.clientService.getClienten$(this.currentPageRequest)),
      )
      .subscribe(page => this.clientenPage$.next(page));
  }

  navigateToAddClient(): void {
    this.router.navigateByUrl('/clienten/toevoegen');
  }

  onPageChange(pageRequest: ClientPageRequest): void {
    this.getClienten$(pageRequest).subscribe();
  }

  private getClienten$(pageRequest: ClientPageRequest): Observable<Page<Client>> {
    this.currentPageRequest = pageRequest;
    return this.clientService
      .getClienten$(pageRequest)
      .pipe(tap(page => this.clientenPage$.next(page)));
  }
}
